import { Link } from "react-router-dom";
import "./PageBackLink.scss";

interface PageBackLinkProps {
	to: string;
	label: string;
	className?: string;
	/** When set, called instead of default navigation (caller may navigate after confirm/async work). */
	onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const PageBackLink = ({ to, label, className, onClick }: PageBackLinkProps) => (
	<Link
		to={to}
		className={className ? `page-back-link ${className}` : "page-back-link"}
		onClick={(event) => {
			if (!onClick) {
				return;
			}
			event.preventDefault();
			onClick(event);
		}}
	>
		<i className="pi pi-arrow-left" aria-hidden />
		{label}
	</Link>
);

export default PageBackLink;
